import React from 'react';

const ActionButton = ({label, clickAction, topOffset}) => {
  const containerStyles = {
    top: topOffset
  };

  const containerClassName = 'canvas-action-button-container';

  return (
    <div onClick={clickAction} className={containerClassName} style={containerStyles}>
      <a className='canvas-action-button' >
        <span className='canvas-action-label'>
          {label}
        </span>
      </a>
    </div>
  );
};

ActionButton.propTypes = {
  clickAction: React.PropTypes.func,
  label: React.PropTypes.string,
  topOffset: React.PropTypes.number
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/ui/canvas/action-button.jsx